<div class="table-scroll-container">
  <table
    mat-table
    [dataSource]="dataSource"
    id="ppwr-overview-table"
    matSort
    [matSortActive]="getActiveSortColumn()"
    [matSortDirection]="getActiveSortDirection()"
    (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('id') }" type="button">
            {{ 'commonPackagingFields.id' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <a class="status-badge gray id-badge" [href]="getPackagingHref(element)" (click)="onIdClick($event, element)">
          {{ element.id }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="brandName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('brandName') }" type="button">
            {{ 'packagingUnit.fields.brandName' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('brandName'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.brandName }}</td>
    </ng-container>

    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('productName') }" type="button">
            {{ 'packagingUnit.fields.productName' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('productName'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.productName }}</td>
    </ng-container>

    <ng-container matColumnDef="articleNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('articleNumber') }" type="button">
            {{ 'packagingUnit.fields.articleNumber' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleNumber'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.articleNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="supplier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('supplier') }" type="button">
            {{ 'packagingUnit.fields.supplier' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('supplier'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.supplier }}</td>
    </ng-container>

    <ng-container matColumnDef="isCompliant">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('isCompliant'), categories: getCompliantOptions() }"
            type="button">
            {{ 'ppwr.overview.columns.isCompliant' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('isCompliant'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span class="status-badge" [class.green]="element.isCompliant === true" [class.red]="element.isCompliant === false" [class.gray]="element.isCompliant === null">
          <ng-container *ngIf="element.isCompliant === true">{{ 'ppwr.overview.compliant.compliant' | transloco }}</ng-container>
          <ng-container *ngIf="element.isCompliant === false">{{ 'ppwr.overview.compliant.nonCompliant' | transloco }}</ng-container>
          <ng-container *ngIf="element.isCompliant === null">{{ 'ppwr.overview.compliant.noStatement' | transloco }}</ng-container>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="isApproved">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('isApproved'), categories: getApprovedOptions() }"
            type="button">
            {{ 'ppwr.overview.columns.isApproved' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('isApproved'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <button
          type="button"
          class="approval-dropdown"
          [class.green]="element.isApproved === true"
          [class.red]="element.isApproved === false"
          [class.gray]="element.isApproved === null"
          [matMenuTriggerFor]="approvalMenu"
          (click)="$event.stopPropagation()">
          <ng-container [ngSwitch]="element.isApproved">
            <ng-container *ngSwitchCase="true">{{ 'ppwr.overview.approved.approved' | transloco }}</ng-container>
            <ng-container *ngSwitchCase="false">{{ 'ppwr.overview.approved.notApproved' | transloco }}</ng-container>
            <ng-container *ngSwitchDefault>{{ 'ppwr.overview.approved.noSelection' | transloco }}</ng-container>
          </ng-container>
          <mat-icon>expand_more</mat-icon>
        </button>

        <mat-menu #approvalMenu="matMenu">
          <button mat-menu-item (click)="onApprovalChange(element, true)">{{ 'ppwr.overview.approved.approved' | transloco }}</button>
          <button mat-menu-item (click)="onApprovalChange(element, false)">{{ 'ppwr.overview.approved.notApproved' | transloco }}</button>
          <button mat-menu-item (click)="onApprovalChange(element, null)">{{ 'ppwr.overview.approved.noSelection' | transloco }}</button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="dataExchangeRequestStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('dataExchangeRequestStatus'), categories: getStatusOptions() }"
            type="button">
            {{ 'ppwr.overview.columns.dataExchangeRequestStatus' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('dataExchangeRequestStatus'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-button
          class="status-link"
          *ngIf="element.dataExchangeRequestStatus !== null && element.dataExchangeRequestStatus !== undefined"
          (click)="onDataExchangeRequestClick(element)">
          {{ getRequestStatusLabel(element.dataExchangeRequestStatus) | transloco }}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="isDocGenerated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('isDocGenerated'), categories: getDocGeneratedOptions() }"
            type="button">
            {{ 'ppwr.overview.columns.isDocGenerated' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('isDocGenerated'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span
          class="status-badge"
          [class.green]="element.isDocGenerated === DocStatusDto.Created"
          [class.gray]="element.isDocGenerated === DocStatusDto.NotCreated"
          [class.red]="element.isDocGenerated === DocStatusDto.OlderVersion">
          <ng-container *ngIf="element.isDocGenerated === DocStatusDto.Created">{{ 'ppwr.overview.doc.created' | transloco }}</ng-container>
          <ng-container *ngIf="element.isDocGenerated === DocStatusDto.NotCreated">{{ 'ppwr.overview.doc.notCreated' | transloco }}</ng-container>
          <ng-container *ngIf="element.isDocGenerated === DocStatusDto.OlderVersion">{{ 'ppwr.overview.doc.olderVersion' | transloco }}</ng-container>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="newestVersionWithDoc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ppwr.overview.columns.newestVersionWithDoc' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.newestVersionWithDoc }}</td>
    </ng-container>

    <ng-container matColumnDef="newestVersionWithTD">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ppwr.overview.columns.newestVersionWithTD' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.newestVersionWithTD }}</td>
    </ng-container>

    <ng-container matColumnDef="technicalDocumentationStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('technicalDocumentationStatus'), categories: getTdStatusOptions() }"
            type="button">
            {{ 'ppwr.overview.columns.technicalDocumentationStatus' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('technicalDocumentationStatus'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span
          class="status-badge"
          [class.green]="element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.Created"
          [class.gray]="element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.NotCreated"
          [class.red]="
            element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.Expired ||
            element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.OlderVersion
          ">
          <ng-container *ngIf="element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.Created">
            {{ 'ppwr.overview.td.created' | transloco }}
          </ng-container>
          <ng-container *ngIf="element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.NotCreated">
            {{ 'ppwr.overview.td.notCreated' | transloco }}
          </ng-container>
          <ng-container *ngIf="element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.Expired">
            {{ 'ppwr.overview.td.expired' | transloco }}
          </ng-container>
          <ng-container *ngIf="element.technicalDocumentationStatus === TechnicalDocumentationStatusDto.OlderVersion">
            {{ 'ppwr.overview.td.olderVersion' | transloco }}
          </ng-container>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" (click)="toggleAllRows()" type="button">
            {{ 'common.buttons.selectAll' | transloco }} <br />
            ({{ selectedIds.length }})
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [checked]="isRowSelected(element)" (change)="toggleRow(element)"></mat-checkbox>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="isRowSelected(row) ? 'background-highlight' : ''"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        {{ 'ppwr.overview.noData' | transloco }}
      </td>
    </tr>

    <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
  </table>

  <div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="48" color="accent"></mat-spinner>
  </div>
</div>

<div class="pagination-row">
  <button *ngIf="showColumnOrganizer" mat-stroked-button class="column-organizer-button" (click)="openColumnSettingsDialog()" type="button">
    <mat-icon>view_column</mat-icon>
    {{ 'common.buttons.organizeColumns' | transloco }}
  </button>
  <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page" (page)="onPageChange($event)"> </mat-paginator>
</div>
